import { Box, Grid, List, useTheme } from "@mui/material";
import FavoriteSong from "components/listItems/FavoriteSong/FavoriteSong";
import CenteredColumnGrid from "components/styled/CenteredColumnGrid";
import React, { useContext } from "react";
import { UserContext } from "utils/UserContext";

function FavoriteSongsList() {
  const { albumTracks } = useContext(UserContext);

  const mainTheme = useTheme();

  return (
    <Box component="section">
      <CenteredColumnGrid container>
        <Grid item>
          <Box
            sx={{
              borderRadius: "1.25rem",
              padding: "10px",
              bgcolor: mainTheme.palette.darkGraySecondary.main,
            }}
          >
            <List>
              {albumTracks.map((track) => (
                <FavoriteSong key={track.id} trackName={track.name} />
              ))}
            </List>
          </Box>
        </Grid>
      </CenteredColumnGrid>
    </Box>
  );
}

export default FavoriteSongsList;
